/** @format */

import {Typography} from '@mui/material';

import {WidgetStatsRoot, widgetStatsClasses as classes} from './style';
import {WidgetStat} from '../../model';

interface Props {
  data: WidgetStat;
}

const WidgetStatsColumn = ({data}: Props) => {
  const {heading, ValueComponent} = data;

  return (
    <WidgetStatsRoot>
      <Typography className={classes.statsHeadingText}>{heading}</Typography>
      {ValueComponent && ValueComponent}
    </WidgetStatsRoot>
  );
};

export default WidgetStatsColumn;
